import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Faltan las variables de entorno de Supabase');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// La autoinscripción usa una sesión independiente del panel administrativo.
// Evita que AuthContext cierre la sesión del socio por no ser un usuario admin.
export const kioskSupabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storageKey: 'maximum-kiosk-auth',
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});

export type Gimnasio = {
  id: string;
  nombre: string;
  slug: string;
  estado: string;
  plan_saas: string;
  created_at: string;
  updated_at: string;
};

export type UsuarioAdmin = {
  id: string;
  auth_id: string;
  email: string;
  nombre: string;
  role: 'platform_admin' | 'gym_admin' | 'staff' | 'admin';
  tipo_staff?: 'general' | 'recepcionista' | 'nutricionista' | 'coach_interno' | 'coach_externo';
  gimnasio_id: string | null;
  sucursal_id: string | null;
  activo: boolean;
  created_at: string;
  updated_at: string;
};

export type Usuario = {
  id: string;
  auth_id?: string | null;
  gimnasio_id?: string | null;
  nombre: string;
  email: string;
  telefono: string;
  whatsapp: string;
  fecha_nacimiento: string;
  tipo_membresia: string;
  tipo_cliente?: 'socio_gimnasio' | 'cliente_externo';
  profesor_admin_id?: string | null;
  fecha_inicio: string;
  fecha_vencimiento: string;
  permanencia_meses_contratada?: number | null;
  pago_exento?: boolean;
  pago_exento_motivo?: string | null;
  pago_exento_hasta?: string | null;
  onboarding_estado?: 'email_pendiente' | 'pago_pendiente' | 'pago_confirmado' | 'biometria_pendiente' | 'completado' | 'error' | null;
  registro_origen?: string | null;
  estado: 'activo' | 'inactivo' | 'vencido';
  sucursal_id: string;
  requiere_captura_facial?: boolean;
  notificar_email: boolean;
  notificar_whatsapp: boolean;
  created_at: string;
  updated_at: string;
};

export type Horario = {
  id: string;
  gimnasio_id?: string | null;
  nombre_clase: string;
  instructor: string | null;
  dia_semana: string;
  hora_inicio: string;
  hora_fin: string;
  capacidad_maxima: number;
  sucursal_id: string;
  activo: boolean;
  created_at: string;
  updated_at: string;
};
